module.exports = __webpack_public_path__ + "img/c02_unitcatapulttriremechampion_Normal_ua.25813dc0.webp";